var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.element.videoURI)?_c('div',{staticStyle:{"max-width":"1000px","margin":"0 auto"}},[_c('VideoPlayer',{attrs:{"id":("watch_video_" + (_vm.element.id)),"url":_vm.element.videoURI}})],1):_c('div',[_vm._v("Video not found")])])}
var staticRenderFns = []

export { render, staticRenderFns }